import { render, staticRenderFns } from "./TopEventList.vue?vue&type=template&id=99203974&"
import script from "./TopEventList.vue?vue&type=script&lang=js&"
export * from "./TopEventList.vue?vue&type=script&lang=js&"
import style0 from "./TopEventList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports